/**
 * Products API
 *
 * API calls related to products and barcode configuration.
 */

import { apiClient } from './client';

export interface BarcodeFieldOption {
  field: string;
  label: string;
  description: string;
}

export interface CustomFieldOption {
  name: string;
  productCount: number;
}

export interface BarcodeFieldOptionsResponse {
  standardFields: BarcodeFieldOption[];
  customFields: CustomFieldOption[];
  hasCustomFields: boolean;
}

export const productsApi = {
  /**
   * Get available barcode field options including custom fields from the catalog
   */
  async getBarcodeFieldOptions(): Promise<BarcodeFieldOptionsResponse> {
    return apiClient.request('/products/barcode-fields');
  },
};
